/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as r from "react";
import { classNames as e } from "@progress/kendo-react-common";
const t = (a) => /* @__PURE__ */ r.createElement("div", { ref: a._ref, className: e("k-toolbar-separator k-separator", a.className) });
export {
  t as ToolbarSeparator
};
